import { SIDENAV_TOKENS } from '@app/components/layout/sidenav/sidenav-tokens';
import { useSidenavContext } from '@app/components/layout/sidenav/SidenavContext';
import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { useIsImpersonationOn } from '@app/core/auth/impersonation/hooks/useIsImpersonationOn';
import { Avatar, Tooltip } from '@mui/material';

/**
 * Tenant (client) logo shown beside the MediaInbox brand while a superadmin
 * is impersonating. Hidden when collapsed — the rail is too narrow for both marks.
 */
export function SidenavTenantLogo() {
  const isImpersonating = useIsImpersonationOn();
  const { client } = useAuth();
  const { collapsed } = useSidenavContext();
  const size = SIDENAV_TOKENS.accountAvatarSize;

  if (!isImpersonating || collapsed || !client) {
    return null;
  }

  return (
    <Tooltip title={client.name} placement="bottom">
      <Avatar
        src={client.logoUrl || undefined}
        alt=""
        data-cy="sidenav-tenant-logo"
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          bgcolor: 'sidenav.avatarFallback',
          border: '1px solid',
          borderColor: 'sidenav.border',
        }}
      >
        {client.name.charAt(0).toUpperCase()}
      </Avatar>
    </Tooltip>
  );
}
